export default "/videos/03726e92f85ca4e514394fec861937ad.mp4";